var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7487 9.69169C9.3352 10.1028 8.66479 10.1028 8.2513 9.69169L0.31012 1.79695C-0.103376 1.38588 -0.103376 0.719387 0.31012 0.308309C0.723616 -0.102769 1.39403 -0.102769 1.80752 0.308309L9 7.45872L16.1925 0.308309C16.606 -0.102769 17.2764 -0.102769 17.6899 0.308309C18.1034 0.719387 18.1034 1.38588 17.6899 1.79695L9.7487 9.69169Z",
    fill: "black"
  })));
};
export default SvgArrow;